import React from 'react'

import * as dates from 'date-arithmetic'
import moment from 'moment';
import { Calendar, Views, Navigate } from 'react-big-calendar'
import TimeGrid from 'react-big-calendar/lib/TimeGrid'
import {CustomWeekView} from "./custom-week-view"

class MyWeek extends React.Component {
  render() {
    const today = new Date();
    let { date } = this.props
    let range = MyWeek.range(date)

return <CustomWeekView range={range} {...this.props}></CustomWeekView>
  }
}


MyWeek.range = date => {
  let start = moment(date).startOf('week').toDate()
  let end =    moment(date).endOf('week').toDate()


  let current = start
  let range = []

  while (dates.lte(current, end, 'day')) {
    range.push(current)
    current = dates.add(current, 1, 'day')
  }

  return range
}

MyWeek.navigate = (date, action) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return dates.add(date, -1, 'week')

    case Navigate.NEXT:
      return dates.add(date,1, 'week')

    default:
      return date
  }
}

MyWeek.title = date => {
  return ` ${date.toLocaleDateString()}`
}

export default MyWeek;